import { useTranslation } from "react-i18next";
import { synthesizeSpeech } from "../../pronunciation";
import { useState, useRef, useEffect } from "react";
import { FILES_ENDPOINT } from "../../api";
import "./TextareaListen.css";

const TextareaListen = ({
    currentlyListening,
    setCurrentlyListening,
    text,
    selectedLanguage,
    setTextareaHasError,
}) => {
    const { t } = useTranslation();
    const audioRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const audio = audioRef.current;
            if (audio?.duration && !audio.paused) {
                setProgress((audio.currentTime / audio.duration) * 100);
            }
        }, 16);

        return () => clearInterval(interval);
    }, [currentlyListening]);

    const handleClick = async () => {
        if (!currentlyListening) {
            if (text === "") {
                setTextareaHasError(true);
            } else {
                setLoading(true);
                try {
                    const result = await synthesizeSpeech(text, selectedLanguage);
                    const url = FILES_ENDPOINT + result.media_url;
                    audioRef.current.src = url;
                    setCurrentlyListening(true);
                    audioRef.current.load();
                    audioRef.current.play();
                } catch (error) {
                    console.error("Synthesis failed:", error);
                } finally {
                    setLoading(false);
                }
            }
        } else {
            setCurrentlyListening(false);
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setProgress(0);
        }
    };

    return (
        <button
            className={`flex items-center bg-gray-100 hover:bg-gray-200 text-black font-medium px-2 py-2 rounded-md border border-border${
                loading ? " gradient-border" : ""
            }`}
            style={{
                backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.05) ${progress}%, transparent ${progress}%)`,
                backgroundBlendMode: "multiply",
            }}
            onClick={handleClick}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={`size-4 mr-1${currentlyListening ? " hidden" : ""}`}
            >
                <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
                <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.5"
                className={`size-4 mr-1${currentlyListening ? "" : " hidden"} `}
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

            {currentlyListening ? t("textarea.cancellisten") : t("textarea.listen")}
            <audio
                ref={audioRef}
                preload="auto"
                onEnded={() => {
                    setCurrentlyListening(false);
                    setProgress(0);
                }}
                /*onTimeUpdate={() => {
                    const audio = audioRef.current;
                    if (audio?.duration) {
                        setProgress((audio.currentTime / audio.duration) * 100);
                        console.log("progress", progress);
                    }
                }}*/
            />
        </button>
    );
};

export default TextareaListen;
